// Textos do Início do DP (26/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.inicio.tela.painel': 'Painel',
    'dp.inicio.tela.prazos': 'Prazos e calendário',
    // Os módulos de 31/10/2026 no Painel e nos cartões de Prazos.
    'dp.painel.tipo.toxicologico': 'Toxicológico',
    'dp.painel.tipo.bonus': 'Bônus',
    'dp.painel.kpi.toxicologico': 'Toxicológico vencido ou sem exame',
    'dp.painel.kpi.bonus': 'Sem bônus por requisito',
    'dp.painel.col.vagas': 'Vagas em aberto',
    'dp.painel.tox.titulo': 'Toxicológico por situação',
    'dp.painel.tox.centro': 'pessoas',
    'dp.painel.tox.escalados': 'Escalados com vencido',
    'dp.painel.tox.rodape': 'Motoristas e quem tem CNH {{toxCategorias}}. O periódico vale {{toxPeriodicoMeses}} meses da coleta; aos {{toxIdade}} anos a pessoa fica isenta.',
    'dp.painel.bonus.titulo': 'Bônus e adicionais, {{rotulo}}',
    'dp.painel.bonus.prazo': 'até {{data}}',
    'dp.painel.bonus.pessoas': 'Pessoas',
    'dp.painel.bonus.rodape': 'A competência em apuração. Linha sem valor para o modelo pede a tabela de valor por hectare.',
    'dp.painel.bonus.naoApurada': 'A competência ainda não foi apurada.',
    'dp.painel.bonus.requisitos': 'Requisitos não cumpridos em {{rotulo}}',
    'dp.painel.bonus.semRequisito': 'Ninguém perdeu o bônus por requisito.',
    'dp.painel.vagas.titulo': 'Contratações',
    'dp.painel.vagas.apoio': '{{n}} posições em aberto',
    'dp.painel.vagas.rodape': 'A vaga não é pessoa: entra aqui e na coluna de vagas do mapa, fora do cruzamento.',
    'dp.painel.vagas.porFase': 'Vagas em aberto por fase',
    'dp.painel.vagas.semVaga': 'Nenhuma vaga em aberto.',
    'dp.painel.rotinas.titulo': 'Rotinas da folha de {{mes}}',
    'dp.painel.rotinas.apoio': '{{feitas}} de {{total}} feitas',
    'dp.painel.rotinas.rodape': 'A agenda do mês, rotina a rotina. O cronograma dos pagamentos e entregas fica no calendário da aba Prazos.',
    'dp.inicio.tox.subtitulo': 'Motoristas e quem tem CNH C, D ou E',
    'dp.inicio.bonus.subtitulo': 'Competência {{rotulo}}, prazo no dia {{bonusPrazoDia}}',
    'dp.inicio.bonus.naoApurada': 'A competência ainda não foi apurada.',
    'dp.inicio.vagas.subtitulo': 'Vagas em aberto, sem prazo de calendário',
    'dp.inicio.vagas.posicoes': 'Posições em aberto',
    'dp.inicio.rotinas.subtitulo': 'Agenda de {{mes}} e checklist da folha',
    'dp.inicio.deslig.semEmail': 'Sem e-mail às áreas',
    'dp.inicio.cnh.semDocumento': 'Sem documento anexado',
    'dp.inicio.cnh.alemDaEsperada': 'Validade acima da esperada',
    'dp.painel.tipo.ponto': 'Ponto',
    'dp.painel.tipo.cnh': 'CNH',
    'dp.painel.tipo.exame': 'Exames',
    'dp.painel.tipo.ferias': 'Férias',
    'dp.painel.tipo.desligamento': 'Rescisões',
    'dp.painel.acumulam': 'Quem acumula pendências',
    'dp.painel.acumulamApoio': '{{n}} pessoas com alguma pendência',
    'dp.painel.acumulamRodape': 'A pessoa é a filial e a matrícula, e cada módulo conta uma vez. O módulo abre a lista dele já buscando a pessoa.',
    'dp.painel.uma': 'Em um módulo',
    'dp.painel.duas': 'Em dois',
    'dp.painel.tres': 'Em três ou mais',
    'dp.painel.ninguemAcumula': 'Ninguém acumula pendência em mais de um módulo.',
    'dp.painel.maisAcumulam': 'E mais {{n}} pessoas.',
    'dp.painel.mapa': 'Mapa do DP por filial',
    'dp.painel.mapaApoio': 'pessoas com pendência em cada módulo',
    'dp.painel.menos': 'Menos',
    'dp.painel.mais': 'Mais',
    'dp.painel.col.quadro': 'Quadro',
    'dp.painel.col.pessoas': 'Com pendência',
    'dp.painel.col.acumulam': 'Acumulam',
    'dp.painel.semDados': 'Sem dados para mostrar.',
    'dp.painel.tipo.gestao': 'Gestões',
    'dp.painel.fila.titulo': 'Fila de pendências',
    'dp.painel.fila.hoje': 'Pendências hoje',
    'dp.painel.fila.emDia': 'Pendências em {{data}}',
    'dp.painel.fila.total': 'Total',
    'dp.painel.fila.caiu': 'Caiu {{n}} em 7 dias',
    'dp.painel.fila.subiu': 'Subiu {{n}} em 7 dias',
    'dp.painel.fila.igual': 'Igual a 7 dias atrás',
    'dp.painel.fila.semBase': 'Ainda sem o dia de 7 dias atrás para comparar.',
    'dp.painel.fila.comparado': 'Em {{data}} eram {{n}}',
    'dp.painel.fila.rodape': 'Uma foto por dia, a meta é que a fila caia. Conta uma pendência por pessoa em cada módulo, e cada gestão pendente de aplicação.',
    'dp.painel.fila.semSerie': 'A série começa no primeiro dia registrado: a fila passa a ser medida a partir dele.',
    'dp.painel.kpi.comPendenciaDica': 'De {{n}} motoristas e operadores, cada pessoa contada uma vez',
    'dp.painel.kpi.comPendencia': 'Pessoas com pendência',
    'dp.painel.kpi.acumulam': 'Em dois módulos ou mais',
    'dp.painel.kpi.ponto': 'Ponto não assinado',
    'dp.painel.kpi.pontoDica': 'Espelho de {{rotulo}}, com o prazo vencido em {{prazo}}',
    'dp.painel.kpi.cnh': 'CNH vencida',
    'dp.painel.kpi.exame': 'Exame vencido',
    'dp.painel.kpi.ferias': 'Férias em risco',
    'dp.painel.kpi.desligamento': 'Rescisão vencida',
    'dp.painel.porFilial': 'Pendências por filial',
    'dp.painel.porFilialRodape': 'Pessoas com pendência em cada módulo, empilhadas: a mesma pessoa aparece uma vez por módulo.',
    'dp.painel.ponto.titulo': 'Assinatura do ponto por competência',
    'dp.painel.ponto.tituloPct': 'Assinatura do ponto, {{pct}}% no prazo em {{rotulo}}',
    'dp.painel.ponto.rodape': 'O espelho se assina até o dia {{pontoPrazoDia}} do mês seguinte. Isentos são recém-admitidos, desligados, afastados e dispensados.',
    'dp.painel.ponto.noPrazo': 'No prazo',
    'dp.painel.ponto.foraDoPrazo': 'Fora do prazo',
    'dp.painel.ponto.pendente': 'Não assinou',
    'dp.painel.ponto.isento': 'Isento',
    'dp.painel.ferias.titulo': 'Férias nas próximas {{feriasSemanas}} semanas',
    'dp.painel.ferias.rodape': 'Cada coluna é uma semana, de segunda a domingo.',
    'dp.painel.ferias.emFerias': 'Em férias',
    'dp.painel.ferias.comecam': 'Começam',
    'dp.painel.ferias.pagamentos': 'Pagamentos',
    'dp.painel.cnh.titulo': 'Vencimento da CNH',
    'dp.painel.cnh.rodape': 'As já vencidas e as que vencem em cada mês. {{sem}} das {{total}} pessoas ainda sem validade registrada, {{semDocumento}} sem o documento anexado e {{alem}} com a validade acima da esperada pela idade.',
    'dp.painel.cnh.vencidas': 'Vencidas',
    'dp.painel.cnh.vencem': 'Vencem no mês',
    'dp.painel.exames': 'Exames de {{mes}}',
    'dp.painel.convocacoes': 'convocações',
    'dp.painel.rescisoes': 'Rescisões abertas por tipo, {{n}} casos, {{semEmail}} sem e-mail às áreas',
    'dp.painel.valePorFilial': 'Vale pago em {{rotulo}}, {{total}}',
    'dp.painel.cortes': 'Cortes do vale em {{rotulo}}',
    'dp.painel.plano': 'Plano de saúde, fatura de {{mes}}',
    'dp.inicio.deslig.subtitulo': 'Pagamento em 10 dias do último dia trabalhado',
    'dp.inicio.ferias.subtitulo': 'Pagamento {{feriasPagamentoUteis}} dias úteis antes do início',
    'dp.inicio.exames.subtitulo': 'Convocações de {{mes}}',
    'dp.inicio.cnh.subtitulo': 'Motoristas e operadores ativos',
    'dp.inicio.plano.subtitulo': 'Fatura de {{mes}}, coparticipação até o dia {{dctfwebDia}}',
    'dp.inicio.plano.semFatura': 'Nenhuma fatura carregada',
    'dp.inicio.data.pj': 'Pagamento dos PJs',
    'dp.inicio.data.guias': 'INSS, FGTS e IR',
    'dp.inicio.titulo': 'Início',
    'dp.inicio.eyebrow': 'Departamento Pessoal',
    'dp.inicio.prazos': 'Prazos em andamento',
    'dp.inicio.calendario': 'Calendário de {{mes}}',
    'dp.inicio.abrir': 'Abrir',
    'dp.inicio.ponto.subtitulo': 'Espelho de {{rotulo}}',
    'dp.inicio.ponto.naoAberta': 'A competência ainda não foi aberta. Abra pela tela ou importe a planilha de controle.',
    'dp.inicio.vale.subtitulo': 'Competência {{rotulo}}',
    'dp.inicio.vale.naoApurada': 'A competência ainda não foi apurada.',
    'dp.inicio.vale.sugeridas': 'Pendências a confirmar',
    'dp.inicio.data.folha': 'Pagamento da folha',
    'dp.inicio.data.folha.obs': '{{folhaDiaUtil}}º dia útil',
    'dp.inicio.data.hapvida': 'Pagamento da Hapvida',
    'dp.inicio.data.esocial': 'Entrega do eSocial',
    'dp.inicio.data.ponto': 'Adiantamento e assinatura do ponto',
    'dp.inicio.data.vale': 'Planilha do vale-alimentação',
    'dp.inicio.data.dctfweb': 'DCTFWeb e coparticipação',
    'dp.inicio.data.unimed': 'Pagamento da Unimed',
    'dp.inicio.passou': 'Passou',
  },
  en: {
    'dp.inicio.tela.painel': 'Dashboard',
    'dp.inicio.tela.prazos': 'Deadlines and calendar',
    'dp.painel.tipo.toxicologico': 'Drug test',
    'dp.painel.tipo.bonus': 'Bonus',
    'dp.painel.kpi.toxicologico': 'Drug test expired or missing',
    'dp.painel.kpi.bonus': 'No bonus for unmet requirement',
    'dp.painel.col.vagas': 'Open positions',
    'dp.painel.tox.titulo': 'Drug test by status',
    'dp.painel.tox.centro': 'people',
    'dp.painel.tox.escalados': 'Scheduled with expired',
    'dp.painel.tox.rodape': 'Drivers and anyone with a {{toxCategorias}} license. The periodic test is valid for {{toxPeriodicoMeses}} months from collection; at {{toxIdade}} the person is exempt.',
    'dp.painel.bonus.titulo': 'Bonuses and allowances, {{rotulo}}',
    'dp.painel.bonus.prazo': 'by {{data}}',
    'dp.painel.bonus.pessoas': 'People',
    'dp.painel.bonus.rodape': 'The pay period being calculated. A line with no value for the model needs the value per hectare table.',
    'dp.painel.bonus.naoApurada': 'The pay period has not been calculated yet.',
    'dp.painel.bonus.requisitos': 'Unmet requirements in {{rotulo}}',
    'dp.painel.bonus.semRequisito': 'Nobody lost the bonus for an unmet requirement.',
    'dp.painel.vagas.titulo': 'Hiring',
    'dp.painel.vagas.apoio': '{{n}} open headcount',
    'dp.painel.vagas.rodape': 'A vacancy is not a person: it shows here and in the map column, outside the cross-check.',
    'dp.painel.vagas.porFase': 'Open vacancies by stage',
    'dp.painel.vagas.semVaga': 'No open vacancies.',
    'dp.painel.rotinas.titulo': 'Payroll routines of {{mes}}',
    'dp.painel.rotinas.apoio': '{{feitas}} of {{total}} done',
    'dp.painel.rotinas.rodape': 'The month agenda, routine by routine. The payment and filing schedule is in the calendar of the Deadlines tab.',
    'dp.inicio.tox.subtitulo': 'Drivers and anyone with a C, D or E license',
    'dp.inicio.bonus.subtitulo': '{{rotulo}} pay period, due on day {{bonusPrazoDia}}',
    'dp.inicio.bonus.naoApurada': 'The pay period has not been calculated yet.',
    'dp.inicio.vagas.subtitulo': 'Open vacancies, no calendar deadline',
    'dp.inicio.vagas.posicoes': 'Open headcount',
    'dp.inicio.rotinas.subtitulo': '{{mes}} agenda and payroll checklist',
    'dp.inicio.deslig.semEmail': 'No e-mail to areas',
    'dp.inicio.cnh.semDocumento': 'No document attached',
    'dp.inicio.cnh.alemDaEsperada': 'Validity beyond expected',
    'dp.painel.tipo.ponto': 'Timesheet',
    'dp.painel.tipo.cnh': 'License',
    'dp.painel.tipo.exame': 'Exams',
    'dp.painel.tipo.ferias': 'Vacations',
    'dp.painel.tipo.desligamento': 'Terminations',
    'dp.painel.acumulam': 'Who piles up pending items',
    'dp.painel.acumulamApoio': '{{n}} people with some pending item',
    'dp.painel.acumulamRodape': 'A person is the branch and employee ID, and each module counts once. The module opens its list already searching the person.',
    'dp.painel.uma': 'In one module',
    'dp.painel.duas': 'In two',
    'dp.painel.tres': 'In three or more',
    'dp.painel.ninguemAcumula': 'Nobody has pending items in more than one module.',
    'dp.painel.maisAcumulam': 'And {{n}} more people.',
    'dp.painel.mapa': 'HR map by branch',
    'dp.painel.mapaApoio': 'people with pending items in each module',
    'dp.painel.menos': 'Less',
    'dp.painel.mais': 'More',
    'dp.painel.col.quadro': 'Staff',
    'dp.painel.col.pessoas': 'With pending',
    'dp.painel.col.acumulam': 'Pile up',
    'dp.painel.semDados': 'No data to show.',
    'dp.painel.tipo.gestao': 'Warnings',
    'dp.painel.fila.titulo': 'Pending queue',
    'dp.painel.fila.hoje': 'Pending today',
    'dp.painel.fila.emDia': 'Pending on {{data}}',
    'dp.painel.fila.total': 'Total',
    'dp.painel.fila.caiu': 'Down {{n}} in 7 days',
    'dp.painel.fila.subiu': 'Up {{n}} in 7 days',
    'dp.painel.fila.igual': 'Same as 7 days ago',
    'dp.painel.fila.semBase': 'No record from 7 days ago to compare yet.',
    'dp.painel.fila.comparado': 'On {{data}} there were {{n}}',
    'dp.painel.fila.rodape': 'One snapshot a day, and the goal is for the queue to fall. Counts one item per person in each module, and each warning waiting to be applied.',
    'dp.painel.fila.semSerie': 'The series starts on the first recorded day: the queue is measured from then on.',
    'dp.painel.kpi.comPendenciaDica': 'Out of {{n}} drivers and operators, each person counted once',
    'dp.painel.kpi.comPendencia': 'People with pending items',
    'dp.painel.kpi.acumulam': 'In two modules or more',
    'dp.painel.kpi.ponto': 'Unsigned timesheet',
    'dp.painel.kpi.pontoDica': '{{rotulo}} timesheet, past the {{prazo}} deadline',
    'dp.painel.kpi.cnh': 'Expired license',
    'dp.painel.kpi.exame': 'Overdue exam',
    'dp.painel.kpi.ferias': 'Vacation at risk',
    'dp.painel.kpi.desligamento': 'Overdue termination',
    'dp.painel.porFilial': 'Pending items by branch',
    'dp.painel.porFilialRodape': 'People with pending items in each module, stacked: the same person shows once per module.',
    'dp.painel.ponto.titulo': 'Timesheet signature by period',
    'dp.painel.ponto.tituloPct': 'Timesheet signature, {{pct}}% on time in {{rotulo}}',
    'dp.painel.ponto.rodape': 'The timesheet is signed by day {{pontoPrazoDia}} of the following month. Exempt are new hires, terminated, on leave and waived.',
    'dp.painel.ponto.noPrazo': 'On time',
    'dp.painel.ponto.foraDoPrazo': 'Late',
    'dp.painel.ponto.pendente': 'Not signed',
    'dp.painel.ponto.isento': 'Exempt',
    'dp.painel.ferias.titulo': 'Vacations in the next {{feriasSemanas}} weeks',
    'dp.painel.ferias.rodape': 'Each column is a week, Monday to Sunday.',
    'dp.painel.ferias.emFerias': 'On vacation',
    'dp.painel.ferias.comecam': 'Start',
    'dp.painel.ferias.pagamentos': 'Payments',
    'dp.painel.cnh.titulo': 'License expiration',
    'dp.painel.cnh.rodape': 'Already expired and those expiring each month. {{sem}} of {{total}} people still without a recorded validity, {{semDocumento}} without the document attached and {{alem}} with validity beyond the expected for their age.',
    'dp.painel.cnh.vencidas': 'Expired',
    'dp.painel.cnh.vencem': 'Expire in the month',
    'dp.painel.exames': 'Exams of {{mes}}',
    'dp.painel.convocacoes': 'exam calls',
    'dp.painel.rescisoes': 'Open terminations by type, {{n}} cases, {{semEmail}} without e-mail to areas',
    'dp.painel.valePorFilial': 'Meal allowance paid in {{rotulo}}, {{total}}',
    'dp.painel.cortes': 'Meal allowance cuts in {{rotulo}}',
    'dp.painel.plano': 'Health plan, invoice of {{mes}}',
    'dp.inicio.deslig.subtitulo': 'Payment within 10 days of the last working day',
    'dp.inicio.ferias.subtitulo': 'Payment {{feriasPagamentoUteis}} business days before the start',
    'dp.inicio.exames.subtitulo': 'Exam calls of {{mes}}',
    'dp.inicio.cnh.subtitulo': 'Active drivers and operators',
    'dp.inicio.plano.subtitulo': 'Invoice of {{mes}}, copayment by day {{dctfwebDia}}',
    'dp.inicio.plano.semFatura': 'No invoice loaded',
    'dp.inicio.data.pj': 'Contractor payments',
    'dp.inicio.data.guias': 'INSS, FGTS and income tax',
    'dp.inicio.titulo': 'Home',
    'dp.inicio.eyebrow': 'Personnel Department',
    'dp.inicio.prazos': 'Open deadlines',
    'dp.inicio.calendario': '{{mes}} calendar',
    'dp.inicio.abrir': 'Open',
    'dp.inicio.ponto.subtitulo': '{{rotulo}} timesheet',
    'dp.inicio.ponto.naoAberta': 'The pay period has not been opened yet. Open it on the screen or import the control spreadsheet.',
    'dp.inicio.vale.subtitulo': '{{rotulo}} pay period',
    'dp.inicio.vale.naoApurada': 'The pay period has not been calculated yet.',
    'dp.inicio.vale.sugeridas': 'Pending months to confirm',
    'dp.inicio.data.folha': 'Payroll payment',
    'dp.inicio.data.folha.obs': 'Business day {{folhaDiaUtil}}',
    'dp.inicio.data.hapvida': 'Hapvida payment',
    'dp.inicio.data.esocial': 'eSocial filing',
    'dp.inicio.data.ponto': 'Salary advance and timesheet signature',
    'dp.inicio.data.vale': 'Meal allowance spreadsheet',
    'dp.inicio.data.dctfweb': 'DCTFWeb and copayment',
    'dp.inicio.data.unimed': 'Unimed payment',
    'dp.inicio.passou': 'Past',
  },
  es: {
    'dp.inicio.tela.painel': 'Panel',
    'dp.inicio.tela.prazos': 'Plazos y calendario',
    'dp.painel.tipo.toxicologico': 'Toxicológico',
    'dp.painel.tipo.bonus': 'Bono',
    'dp.painel.kpi.toxicologico': 'Toxicológico vencido o sin examen',
    'dp.painel.kpi.bonus': 'Sin bono por requisito',
    'dp.painel.col.vagas': 'Vacantes abiertas',
    'dp.painel.tox.titulo': 'Toxicológico por situación',
    'dp.painel.tox.centro': 'personas',
    'dp.painel.tox.escalados': 'Escalados con vencido',
    'dp.painel.tox.rodape': 'Conductores y quien tiene licencia {{toxCategorias}}. El periódico vale {{toxPeriodicoMeses}} meses desde la toma; a los {{toxIdade}} años la persona queda exenta.',
    'dp.painel.bonus.titulo': 'Bonos y adicionales, {{rotulo}}',
    'dp.painel.bonus.prazo': 'hasta {{data}}',
    'dp.painel.bonus.pessoas': 'Personas',
    'dp.painel.bonus.rodape': 'El período en cálculo. La línea sin valor para el modelo pide la tabla de valor por hectárea.',
    'dp.painel.bonus.naoApurada': 'El período aún no fue calculado.',
    'dp.painel.bonus.requisitos': 'Requisitos no cumplidos en {{rotulo}}',
    'dp.painel.bonus.semRequisito': 'Nadie perdió el bono por requisito.',
    'dp.painel.vagas.titulo': 'Contrataciones',
    'dp.painel.vagas.apoio': '{{n}} posiciones abiertas',
    'dp.painel.vagas.rodape': 'La vacante no es persona: entra aquí y en la columna de vacantes del mapa, fuera del cruce.',
    'dp.painel.vagas.porFase': 'Vacantes abiertas por fase',
    'dp.painel.vagas.semVaga': 'Ninguna vacante abierta.',
    'dp.painel.rotinas.titulo': 'Rutinas de nómina de {{mes}}',
    'dp.painel.rotinas.apoio': '{{feitas}} de {{total}} hechas',
    'dp.painel.rotinas.rodape': 'La agenda del mes, rutina por rutina. El cronograma de pagos y entregas está en el calendario de la pestaña Plazos.',
    'dp.inicio.tox.subtitulo': 'Conductores y quien tiene licencia C, D o E',
    'dp.inicio.bonus.subtitulo': 'Período {{rotulo}}, plazo el día {{bonusPrazoDia}}',
    'dp.inicio.bonus.naoApurada': 'El período aún no fue calculado.',
    'dp.inicio.vagas.subtitulo': 'Vacantes abiertas, sin plazo de calendario',
    'dp.inicio.vagas.posicoes': 'Posiciones abiertas',
    'dp.inicio.rotinas.subtitulo': 'Agenda de {{mes}} y checklist de la nómina',
    'dp.inicio.deslig.semEmail': 'Sin correo a las áreas',
    'dp.inicio.cnh.semDocumento': 'Sin documento adjunto',
    'dp.inicio.cnh.alemDaEsperada': 'Validez por encima de la esperada',
    'dp.painel.tipo.ponto': 'Asistencia',
    'dp.painel.tipo.cnh': 'Licencia',
    'dp.painel.tipo.exame': 'Exámenes',
    'dp.painel.tipo.ferias': 'Vacaciones',
    'dp.painel.tipo.desligamento': 'Desvinculaciones',
    'dp.painel.acumulam': 'Quién acumula pendientes',
    'dp.painel.acumulamApoio': '{{n}} personas con algún pendiente',
    'dp.painel.acumulamRodape': 'La persona es la filial y la matrícula, y cada módulo cuenta una vez. El módulo abre su lista ya buscando a la persona.',
    'dp.painel.uma': 'En un módulo',
    'dp.painel.duas': 'En dos',
    'dp.painel.tres': 'En tres o más',
    'dp.painel.ninguemAcumula': 'Nadie acumula pendientes en más de un módulo.',
    'dp.painel.maisAcumulam': 'Y {{n}} personas más.',
    'dp.painel.mapa': 'Mapa del DP por filial',
    'dp.painel.mapaApoio': 'personas con pendientes en cada módulo',
    'dp.painel.menos': 'Menos',
    'dp.painel.mais': 'Más',
    'dp.painel.col.quadro': 'Plantilla',
    'dp.painel.col.pessoas': 'Con pendiente',
    'dp.painel.col.acumulam': 'Acumulan',
    'dp.painel.semDados': 'Sin datos para mostrar.',
    'dp.painel.tipo.gestao': 'Gestiones',
    'dp.painel.fila.titulo': 'Fila de pendientes',
    'dp.painel.fila.hoje': 'Pendientes hoy',
    'dp.painel.fila.emDia': 'Pendientes el {{data}}',
    'dp.painel.fila.total': 'Total',
    'dp.painel.fila.caiu': 'Bajó {{n}} en 7 días',
    'dp.painel.fila.subiu': 'Subió {{n}} en 7 días',
    'dp.painel.fila.igual': 'Igual que hace 7 días',
    'dp.painel.fila.semBase': 'Aún sin el día de hace 7 días para comparar.',
    'dp.painel.fila.comparado': 'El {{data}} eran {{n}}',
    'dp.painel.fila.rodape': 'Una foto por día, la meta es que la fila baje. Cuenta un pendiente por persona en cada módulo, y cada gestión pendiente de aplicación.',
    'dp.painel.fila.semSerie': 'La serie empieza el primer día registrado: la fila se mide a partir de él.',
    'dp.painel.kpi.comPendenciaDica': 'De {{n}} conductores y operadores, cada persona contada una vez',
    'dp.painel.kpi.comPendencia': 'Personas con pendiente',
    'dp.painel.kpi.acumulam': 'En dos módulos o más',
    'dp.painel.kpi.ponto': 'Hoja sin firmar',
    'dp.painel.kpi.pontoDica': 'Hoja de {{rotulo}}, con el plazo vencido el {{prazo}}',
    'dp.painel.kpi.cnh': 'Licencia vencida',
    'dp.painel.kpi.exame': 'Examen vencido',
    'dp.painel.kpi.ferias': 'Vacaciones en riesgo',
    'dp.painel.kpi.desligamento': 'Desvinculación vencida',
    'dp.painel.porFilial': 'Pendientes por filial',
    'dp.painel.porFilialRodape': 'Personas con pendiente en cada módulo, apiladas: la misma persona aparece una vez por módulo.',
    'dp.painel.ponto.titulo': 'Firma de la asistencia por período',
    'dp.painel.ponto.tituloPct': 'Firma de la asistencia, {{pct}}% en plazo en {{rotulo}}',
    'dp.painel.ponto.rodape': 'La hoja se firma hasta el día {{pontoPrazoDia}} del mes siguiente. Exentos son recién admitidos, desvinculados, de licencia y dispensados.',
    'dp.painel.ponto.noPrazo': 'En plazo',
    'dp.painel.ponto.foraDoPrazo': 'Fuera de plazo',
    'dp.painel.ponto.pendente': 'No firmó',
    'dp.painel.ponto.isento': 'Exento',
    'dp.painel.ferias.titulo': 'Vacaciones en las próximas {{feriasSemanas}} semanas',
    'dp.painel.ferias.rodape': 'Cada columna es una semana, de lunes a domingo.',
    'dp.painel.ferias.emFerias': 'De vacaciones',
    'dp.painel.ferias.comecam': 'Empiezan',
    'dp.painel.ferias.pagamentos': 'Pagos',
    'dp.painel.cnh.titulo': 'Vencimiento de la licencia',
    'dp.painel.cnh.rodape': 'Las ya vencidas y las que vencen cada mes. {{sem}} de las {{total}} personas aún sin validez registrada, {{semDocumento}} sin el documento adjunto y {{alem}} con la validez por encima de la esperada por la edad.',
    'dp.painel.cnh.vencidas': 'Vencidas',
    'dp.painel.cnh.vencem': 'Vencen en el mes',
    'dp.painel.exames': 'Exámenes de {{mes}}',
    'dp.painel.convocacoes': 'convocatorias',
    'dp.painel.rescisoes': 'Desvinculaciones abiertas por tipo, {{n}} casos, {{semEmail}} sin correo a las áreas',
    'dp.painel.valePorFilial': 'Vale pagado en {{rotulo}}, {{total}}',
    'dp.painel.cortes': 'Cortes del vale en {{rotulo}}',
    'dp.painel.plano': 'Plan de salud, factura de {{mes}}',
    'dp.inicio.deslig.subtitulo': 'Pago en 10 días del último día trabajado',
    'dp.inicio.ferias.subtitulo': 'Pago {{feriasPagamentoUteis}} días hábiles antes del inicio',
    'dp.inicio.exames.subtitulo': 'Convocatorias de {{mes}}',
    'dp.inicio.cnh.subtitulo': 'Conductores y operadores activos',
    'dp.inicio.plano.subtitulo': 'Factura de {{mes}}, copago hasta el día {{dctfwebDia}}',
    'dp.inicio.plano.semFatura': 'Ninguna factura cargada',
    'dp.inicio.data.pj': 'Pago de los contratistas',
    'dp.inicio.data.guias': 'INSS, FGTS e impuesto a la renta',
    'dp.inicio.titulo': 'Inicio',
    'dp.inicio.eyebrow': 'Departamento de Personal',
    'dp.inicio.prazos': 'Plazos en curso',
    'dp.inicio.calendario': 'Calendario de {{mes}}',
    'dp.inicio.abrir': 'Abrir',
    'dp.inicio.ponto.subtitulo': 'Hoja de {{rotulo}}',
    'dp.inicio.ponto.naoAberta': 'El período aún no fue abierto. Ábralo en la pantalla o importe la planilla de control.',
    'dp.inicio.vale.subtitulo': 'Período {{rotulo}}',
    'dp.inicio.vale.naoApurada': 'El período aún no fue calculado.',
    'dp.inicio.vale.sugeridas': 'Pendientes por confirmar',
    'dp.inicio.data.folha': 'Pago de la nómina',
    'dp.inicio.data.folha.obs': '{{folhaDiaUtil}}º día hábil',
    'dp.inicio.data.hapvida': 'Pago de Hapvida',
    'dp.inicio.data.esocial': 'Entrega de eSocial',
    'dp.inicio.data.ponto': 'Anticipo y firma de la hoja de asistencia',
    'dp.inicio.data.vale': 'Planilla del vale de alimentación',
    'dp.inicio.data.dctfweb': 'DCTFWeb y copago',
    'dp.inicio.data.unimed': 'Pago de Unimed',
    'dp.inicio.passou': 'Pasó',
  },
}
